<template lang="pug">
  include ../../../../pug/mixins/bem.pug
  +b.filterable-list
    .inner-wrap
      slot(:items='prop', :load='isLoad')
</template>
<script>

import axios from 'axios'

export default {
  name: "FilterableList",
  props: ['naviagatable', 'url', 'refetch'],
  data() {
    return {
      value: '',
      prop: {
        meta: {},
        data: []
      },
      prop_: [],
      isLoad: false,
      promises: [],
      active: true
    }
  },
  mounted() {
   
  },
  methods: {
    historyReplace() {
      if (this.naviagatable) {
        history.pushState({'url': this.url}, '', `${this.url}`)
      }
    },
    paginate(event, filters) {
      //console.log(event, filters)
    },
    
    getCookie(name) {
      var matches = document.cookie.match(new RegExp(
        `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
      ))
      return matches ? decodeURIComponent(matches[1]) : undefined
    },
    async fetchData(url) {
      this.isLoad = true
      return await axios.get(`${url}`, {headers: {'Accept-Language': window.language,
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRFToken": this.getCookie("csrftoken")}})
        .then(res => {
          this.prop_ = res.data
          // if (this.prop_.data) {
          //   let dataStr = this.prop_.data
          //   if ("string" == typeof this.prop_.data) {
          //     this.prop_.data = dataStr.replace(/&#39;/g, '\'')
          //     let trueReg = /True/g
          //     this.prop_.data = this.prop_.data.replace(trueReg, true)
          //     this.prop_.data = this.prop_.data.replace(/False/g, false)
          //     this.prop_.data = this.prop_.data.replace(/None/g, false)
          //   }
          // }
          this.prop.meta = res.data.meta 
          this.prop.data.push(res.data.data)

          this.isLoad = false
         
        }).then(this.historyReplace)
    }


  },
  watch: {
    url: {
      async handler(nval) {
       
        this.promises.push(this.fetchData(nval))
        Promise.all(this.promises)
          .then(res => {
            this.promises = []
          })
          
        
        // await this.fetchData(nval)
      }
      
    },
    refetch() {
      this.fetchData(this.url)
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/js/shared/components/articles/FilterableList.vue